import * as $ from 'jquery';
import { isAndroid } from '../widget-core/storage';

export default function detectBrowser(): void {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('safari') !== -1) {
        if (userAgent.indexOf('chrome') > -1) {
            // Browser is chrome
        } else if ((userAgent.indexOf('opera') > -1) || (userAgent.indexOf('opr') > -1)) {
            // Browser is opera
        } else {
            // Browser is safari
            $('html').addClass('safari');
        }
    }

    if (isAndroid) {
        // Is android
        $('html').addClass('android');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/bundle/browser-detection.ts